var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ewem-app"}},[_c('TheAppHeader'),_c('main',{staticClass:"ewem-main"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }